import { format } from 'date-fns'
import noLocale from 'date-fns/locale/nb'

export const formatDateTime = (dateTime: Date): string =>
  format(dateTime, 'dd.MM.yyyy, HH:mm', { locale: noLocale })
